module.exports = __webpack_public_path__ + "static/media/arrowRightLastItemGrey.6c8b53f7.svg";